export const MODULES = {
    HOME: 'Home',
    ABOUT: 'About',
    USER_HOME: 'User Home',
    BARQLYTICS: "Barqlytics",
    USER_PROFILE: 'User Profile',
    COMMENTS: 'Comments',
    TENANTS: 'Tenants',
    USERS: 'User',
    MODULES: 'Modules',
    ROLES: 'Role',
    CONTRACTS: 'Contracts',
    PROJECTS: 'Projects',
    PROJECT_TASKS: 'Project Tasks',
    GENERAL_TASKS: 'General Tasks',
    TASK_ASSIGNMENTS: 'Task Assignments',
    UPLOADS: 'Uploads',
    NOTIFICATION: 'Notification',
    REMINDERS: 'Reminders',
    
    INVENTORIES: 'Inventories',
    PAYROLL: 'Payroll',
    VEHICLES: 'Vehicles',
    VEHICLE_INSURANCE: 'Vehicle Insurance',
    ATTENDANCE: 'Attendance',
    PAYMENTS: 'Payments',
    ESTIMATIONS: 'Estimations',
    REPORTS: 'Reports',
    GST: 'GST',
   
    // Admin-specific or configuration modules
    USER_ROLE_MAPPING: 'UserRoleMapping',
    ROLE_MODULE_PERMISSIONS: 'RoleModulePermissions',
    USER_MODULE_PERMISSIONS: 'UserModulePermissions',
    USER_ROLE_ASSIGNMENT: 'UserRoles',
  };

  // Entity Types that can support file uploads
export const ENTITY_TYPES = {
  CONTRACT: 'CONTRACT',
  PROJECT: 'PROJECT',
  PROJECT_TASK: 'PROJECT_TASK',
  GENERAL_TASK: 'GENERAL_TASK',
  USER: 'USER',
  VENDOR: 'VENDOR',
  TENANT: 'TENANT',
  VEHICLE: 'VEHICLE',
  VEHICLE_INSURANCE: 'VEHICLE_INSURANCE',
  ATTENDANCE: 'ATTENDANCE',
  PAYROLL: 'PAYROLL',
  PAYMENT: 'PAYMENT',
  ESTIMATION: 'ESTIMATION',
  GST: 'GST',
  REPORT: 'REPORT',
  NOTIFICATION: 'NOTIFICATION',
  REMINDER: 'REMINDER',
  INVENTORY: 'INVENTORY',
  DOCUMENT_LIBRARY: 'DOCUMENT_LIBRARY', // For global/general uploads
};

export const UPLOAD_BUCKETS = {
  TADWIRO: 'tadwiro',
  GENERAL: 'general', // For global uploads
};
export const UPLOAD_STATUSES = {
  READY: 'ready',
  UPLOADING: 'uploading',
  SUCCESS: 'success',
  ERROR: 'error',
};
export const UPLOAD_STATUS_MESSAGES = {
  [UPLOAD_STATUSES.READY]: 'Ready to upload',
  [UPLOAD_STATUSES.UPLOADING]: 'Uploading...',
  [UPLOAD_STATUSES.SUCCESS]: 'Upload successful',
  [UPLOAD_STATUSES.ERROR]: 'Upload failed',
};
export const UPLOAD_ERROR_MESSAGES = {
  FILE_SIZE_EXCEEDED: 'File size exceeds the maximum limit',
  INVALID_FILE_TYPE: 'Invalid file type',
  UPLOAD_FAILED: 'Upload failed. Please try again.',
  NO_FILES_SELECTED: 'No files selected for upload',
  GENERIC_ERROR: 'An unexpected error occurred. Please try again later.',
};
export const MAX_FILE_SIZE_MB = 10; // Maximum file size in MB
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024; // Convert to bytes  
export const ALLOWED_FILE_TYPES = [
  'image/jpeg',
  'image/png',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/plain',
  // Add more allowed MIME types as needed
];
export const UPLOAD_METADATA_KEYS = {
  ENTITY_TYPE: 'entityType',
  ENTITY_ID: 'entityId',
  UPLOADED_BY: 'uploadedBy',
  UPLOADED_AT: 'uploadedAt',
  FILE_DESCRIPTION: 'fileDescription',
  FILE_TAGS: 'fileTags',
};
// Upload Types: Context or usage of the upload
export const UPLOAD_TYPES = {
  PROFILE_PICTURE: 'PROFILE_PICTURE',
  DOCUMENT: 'DOCUMENT',
  SUPPORTING_DOCUMENT: 'SUPPORTING_DOCUMENT',
  VIDEO: 'VIDEO',
  IMAGE: 'IMAGE',
  AUDIO: 'AUDIO',
  CONTRACT_PDF: 'CONTRACT_PDF',
  REPORT_FILE: 'REPORT_FILE',
  TASK_ATTACHMENT: 'TASK_ATTACHMENT',
  INSURANCE_PDF: 'INSURANCE_PDF',
  GST_FILE: 'GST_FILE',
  VEHICLE_RC: 'VEHICLE_RC',
  PAYROLL_SLIP: 'PAYROLL_SLIP',
  OTHER: 'OTHER',
};
export enum EntityType {
  CONTRACT = 'CONTRACT',
  PROJECT = 'PROJECT',
  PROJECT_TASK = 'PROJECT_TASK',
  GENERAL_TASK = 'GENERAL_TASK',
  USER = 'USER',
  VENDOR = 'VENDOR',
  TENANT = 'TENANT',
  VEHICLE = 'VEHICLE',
  VEHICLE_INSURANCE = 'VEHICLE_INSURANCE',
  ATTENDANCE = 'ATTENDANCE',
  PAYROLL = 'PAYROLL',
  PAYMENT = 'PAYMENT',
  ESTIMATION = 'ESTIMATION',
  GST = 'GST',
  REPORT = 'REPORT',
  NOTIFICATION = 'NOTIFICATION',
  REMINDER = 'REMINDER',
  INVENTORY = 'INVENTORY',
  DOCUMENT_LIBRARY = 'DOCUMENT_LIBRARY',
}

export enum UploadType {
  PROFILE_PICTURE = 'PROFILE_PICTURE',
  DOCUMENT = 'DOCUMENT',
  SUPPORTING_DOCUMENT = 'SUPPORTING_DOCUMENT',
  VIDEO = 'VIDEO',
  IMAGE = 'IMAGE',
  AUDIO = 'AUDIO',
  CONTRACT_PDF = 'CONTRACT_PDF',
  REPORT_FILE = 'REPORT_FILE',
  TASK_ATTACHMENT = 'TASK_ATTACHMENT',
  INSURANCE_PDF = 'INSURANCE_PDF',
  GST_FILE = 'GST_FILE',
  VEHICLE_RC = 'VEHICLE_RC',
  PAYROLL_SLIP = 'PAYROLL_SLIP',
  OTHER = 'OTHER',
}

export const UploadContexts = {
  CONTRACT_SUPPORT_DOCS: {
    module: "CONTRACTS",
    uploadType: "SUPPORTING_DOCS",
    maxFiles: 10,
    allowedFileTypes: [
      "application/pdf",
      "image/*",
      "application/msword",
      "video/*",
    ],
    label: "Upload Supporting Documents for Contract",
  },

  PROJECT_ATTACHMENTS: {
    module: "PROJECTS",
    uploadType: "ATTACHMENTS",
    maxFiles: 5,
    allowedFileTypes: ["application/pdf", "image/*", "application/zip"],
    label: "Upload Project Attachments",
  },

  TASK_COMMENTS_FILES: {
    module: "TASKS",
    uploadType: "COMMENT_FILES",
    maxFiles: 3,
    allowedFileTypes: ["image/*", "application/pdf", "text/plain"],
    label: "Upload Files for Task Comments",
  },

  USER_PROFILE_PICTURE: {
    module: "USERS",
    uploadType: "PROFILE_PICTURE",
    maxFiles: 1,
    allowedFileTypes: ["image/jpeg", "image/png"],
    label: "Upload User Profile Picture",
  },

  USER_DOCUMENTS: {
    module: "USERS",
    uploadType: "IDENTITY_DOCS",
    maxFiles: 5,
    allowedFileTypes: [
      "application/pdf",
      "image/*",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ],
    label: "Upload Identity Documents",
  },

  EXPENSE_RECEIPTS: {
    module: "EXPENSES",
    uploadType: "RECEIPTS",
    maxFiles: 10,
    allowedFileTypes: ["image/*", "application/pdf"],
    label: "Upload Expense Receipts",
  },

  REPORT_ATTACHMENTS: {
    module: "REPORTS",
    uploadType: "ATTACHMENTS",
    maxFiles: 5,
    allowedFileTypes: ["application/pdf", "application/vnd.ms-excel", "application/zip"],
    label: "Upload Report Attachments",
  },

  FEEDBACK_MEDIA: {
    module: "FEEDBACK",
    uploadType: "MEDIA_FILES",
    maxFiles: 3,
    allowedFileTypes: ["image/*", "video/*", "audio/*"],
    label: "Upload Media for Feedback",
  },

  SUPPORT_TICKETS: {
    module: "SUPPORT",
    uploadType: "TICKET_FILES",
    maxFiles: 5,
    allowedFileTypes: ["application/pdf", "image/*", "text/plain"],
    label: "Upload Files for Support Tickets",
  },

  ANNOUNCEMENT_BANNERS: {
    module: "ANNOUNCEMENTS",
    uploadType: "BANNERS",
    maxFiles: 1,
    allowedFileTypes: ["image/jpeg", "image/png", "image/webp"],
    label: "Upload Announcement Banner",
  },
};